import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-visitor',
  templateUrl: './visitor.component.html',
  styleUrls: ['./visitor.component.css'],
})
export class VisitorComponent {
  url: string = 'users';
  form!: FormGroup;
  roles: Array<any> = [];
  identifications: Array<any> = [];
  indicatives: Array<any> = [];
  countries: Array<any> = [];
  backgrounds: Array<any> = [];
  upload = false;
  upload_two = false;
  apiUrl = environment.apiUrl;
  imagePreviews: { [key: string]: string } = {};
  showPassword = false;
  showPasswordTwo = false;

  uploadStatus = {
    contract: false,
    nda: false,
    licensesMedical: false,
    insurance: false,
    licensesLeave: false,
  };

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
    private http: HttpClient
  ) {
    this.form = this.fb.group(
      {
        username: ['', [Validators.required]],
        firstname: ['', [Validators.required]],
        lastname: ['', [Validators.required]],
        status: [false],
        password: ['', [Validators.required]],
        confirmPassword: ['', [Validators.required]],
        indicative: ['', [Validators.required]],
        phone: ['', [Validators.required]],
        twoFAEnabled: [true],
      },
      { validators: this.passwordMatchValidator() }
    );
  }

  ngOnInit(): void {
    this.indicatives = [
      '+1',
      '+57',
      '+52',
      '+55',
      '+54',
      '+56',
      '+58',
      '+34',
      '+44',
    ];
  }

  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }

  onSubmit(): void {
    this.createData();
  }

  createData(): void {
    const formData = {
      ...this.form.value,
    };

    this.dataService
      .postData(`${this.url}/registerVisitor`, formData)
      .subscribe((response) => {
        console.log('response', response);
        if (response.rst) {
          this.form.reset();
          this.router.navigateByUrl('/pages/login');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  /* formatPhone() {
    const phoneNumber = (this.form.get('phone')?.value || '').replace(
      /[^\d]/g,
      ''
    );

    const phoneNumberLength = (this.form.get('phone')?.value || '').length;
    console.log('logitud');
    console.log(phoneNumberLength);
    if (phoneNumberLength <= 3) {
      //this.data.phone = phoneNumber.slice(0, 3);
      this.form.patchValue({
        phone: phoneNumber.slice(0, 3),
      });
    } else if (phoneNumberLength == 4) {
      //this.data.phone =        '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 4);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 4),
      });
    } else if (phoneNumberLength == 5) {
      //this.data.phone = '(' + phoneNumber.slice(0, 3);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3),
      });
    } else if (phoneNumberLength == 6) {
      //this.data.phone =        '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6);
      //console.log(this.data.phone);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6),
      });
    } else if (phoneNumberLength == 7) {
      //this.data.phone =        '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6),
      });
    } else if (phoneNumberLength == 8) {
      //this.data.phone =        '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6),
      });
    } else if (phoneNumberLength == 9) {
      //this.data.phone =        '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6);
      this.form.patchValue({
        phone: '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6),
      });
    } else if (phoneNumberLength == 10) {
      //this.data.phone = '(' + phoneNumber.slice(0, 3) +   ') ' + phoneNumber.slice(3, 6) + ' - ' + phoneNumber.slice(6, 10);
      this.form.patchValue({
        phone:
          '(' +
          phoneNumber.slice(0, 3) +
          ') ' +
          phoneNumber.slice(3, 6) +
          ' - ' +
          phoneNumber.slice(6, 10),
      });
    }
  } */

    formatPhone(event: Event) {
      const input = event.target as HTMLInputElement;
  
      let digits = input.value.replace(/\D/g, '');
      digits = digits.slice(0, 10);
  
      let formatted = '';
      if (digits.length <= 3) {
        formatted = digits;
      } else if (digits.length <= 6) {
        formatted = `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
      } else {
        formatted = `(${digits.slice(0, 3)}) ${digits.slice(
          3,
          6
        )} - ${digits.slice(6)}`;
      }
  
      this.form.get('phone')?.setValue(formatted, { emitEvent: false });
    }

  passwordMatchValidator(): ValidatorFn {
    return (group: AbstractControl): { [key: string]: any } | null => {
      const password = group.get('password')?.value;
      const confirmPassword = group.get('confirmPassword')?.value;

      return password === confirmPassword ? null : { mismatch: true };
    };
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  togglePasswordVisibilityTwo() {
    this.showPasswordTwo = !this.showPasswordTwo;
  }
}